<style lang="scss" scoped>
	.channelName{
		width: 55%;
		float: left;
		margin-right: 10px;
	}
	.creareform .vview-formitem {
    margin-bottom: 10px;
	line-height: 32px;

}
</style>

<template>
    <div>
        <div class="bg-fff padding-top-20">
            <span class="margin-left-20">{{$t('erp.channelbase.channel_code', { defaultValue: '渠道代码' })}}: <span class="font-bold">{{flag}}</span></span>
            <span class="margin-left-20">{{$t('erp.channelbase.channel_title', { defaultValue: '渠道标题' })}}: <span class="font-bold">{{title}}</span></span>
            <span class="margin-left-20 font-bold">{{isSite == true ? '未单独设定，沿用站点' : '已单独设定'}}</span>
        </div>
        
        <div class="search-wrap bg-fff padding-top-10">
            <article class="search-main clearfix padding-left-15">
                <Button type="warning" @click.native="clickclear">{{$t('erp.channelbase.clear_all', { defaultValue: '全部清除' })}}</Button>
                <div class="pull-right">
                    <Form inline>
                        <Button type="primary" @click.native="update('new')" icon="ios-search">{{$t('global.common.search', { defaultValue: '搜索' })}}</Button>
                        <Button @click.native="reset" icon='md-refresh'>{{$t('global.common.reset', { defaultValue: '重置' })}}</Button>
                        <vButton theme="dashed" style="margin-left:5px;" ghost @click.native="isOpen=!isOpen" >{{$t('global.common.btn_more', { defaultValue: '更多查询' })}}&nbsp;<vIcon type="ios-arrow-down"></vIcon></vButton>
                    </Form>
                </div>
                <div class="pull-right">
                    <Form :label-width="120" inline>
                        <FormItem :label="$t('erp.channelbase.channel_carrier', { defaultValue: '渠道carrier' })">
                            <vInput v-model="formData.accountCarrier"></vInput>
                        </FormItem>
                        <FormItem :label="$t('erp.channelbase.channel_methods_code', { defaultValue: '渠道Method Code' })">
                            <vInput v-model="formData.accountSmc"></vInput>
                        </FormItem>
                    </Form>
                </div>

            </article>
            <transition name='slide-both'>
                <Form :label-width="90" inline v-show="isOpen">
                    <!-- <FormItem :label="$t('erp.channelbase.system_delivery_type', { defaultValue: '系统发运方式' })"> -->
                    <FormItem label="系统Carrier Service Code">
                        <Select v-model="formData.bossSmc" filterable clearable>
                            <Option v-for="(item,index) in newSysdeliveries" :value="item.carrierServiceCode" :key="index">{{ item.carrierServiceCode }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem :label="$t('erp.channelbase.is_disable', { defaultValue: '是否禁用' })">
                        <Select v-model="formData.status" filterable clearable>
                            <Option v-for="(item,index) in statuslist" :value="item.value" :key="index">{{ item.label }}</Option>
                        </Select>
                    </FormItem>

                </Form>
            </transition>
        </div>
        <vTable
        class="margin-top-20"
        :loading="loading"
        :columns="columns"
        :data="formList"
        size="small"
        ref="table"
        border
        ></vTable>

        <div class="text-right padding-right-20 margin-top-20">
            <vButton v-show="lastbtn" theme="info" @click="lastPage">{{$t('global.page.pre', { defaultValue: '上一页' })}}</vButton>
            <vButton v-show="nextbtn" class="margin-left-10" @click="nextPage">{{$t('global.page.next', { defaultValue: '下一页' })}}</vButton>
            <vButton v-show="showsubmit" class="margin-left-10" theme="primary" @click="submit">{{$t('fbb.inbound.common_save_and_commit', { defaultValue: '保存并提交' })}}</vButton>
        </div>

        <!-- 全局弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps={}"
		>
            <component ref="cusref" :is="modalProps.component" @on-close="modalProps={}" v-bind="modalProps" ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </compModal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { HttpGetAccountShipping, HttpSaveAccountShipping, HttpClearAll } from "@/service/managechannel/managechannel";
import { mapState } from "vuex";
import { connect } from 'net';
export default {
    data(){
        return{
            lastbtn:false,
            nextbtn:false,
            showsubmit:false,
            totalNumber:0,
            id:this.$route.query.id,
            formData:{
                page: 1,
				rows: 10,
				sidx: "id",
				sord: "desc",
                accountCarrier:'',
                accountSmc:'',
                bossSmc:'',
                status:'',
            },
            modalProps:{
                show:false
            },
            datalist:[],
            statuslist:[
                {
                    value: 'ACTIVE',
                    label: this.$t('erp.global.yes', { defaultValue: '是' })
                },
                {
                    value: 'INACTIVE',
                    label: this.$t('erp.global.no', { defaultValue: '否' })
                },
            ],
            flag:this.$route.query.flag,
            title:this.$route.query.title,
            loading:false,
            isOpen: false,
            arrayList:[],
            isSite:false,
        }
    },
    components: {
        compModal: () => import("@components/templates/modal"),
	},
	computed: {
        ...mapState('boss', ['accounts','products','warehouseList','sysdeliveries', 'newSysdeliveries']),
        formList(){
            return this.datalist || []
        },
        columns(){
            const _this = this;
            return [
                {
                    title: this.$t('erp.accountShipment.index', { defaultValue: '渠道发运方式' }),
                    render:(h,{row})=>{
                        return <div>
                            <div>Carrier:{row.accountCarrier}</div>
                            <div>Method Code:{row.accountSmc}</div>
                        </div>
                    }
                },

                {
                    title: this.$t('erp.channelbase.system_delivery_type', { defaultValue: '系统发运方式' }),
                    key: 'bossSmc',
                    render:(h,{row,index})=>{
                        console.log("sys", this.sysdeliveries, this.newSysdeliveries);
                        return h('Select',{
                            props:{
                                filterable:true,
                                clearable:true,
                                value: _this.datalist[index].bossSmc,
                            },
                            on: {
                                'on-change':(value) => {
                                    console.log(value,index)
                                    _this.datalist[index].bossSmc = value
                                }
                            },
                        },
                        _this.newSysdeliveries.map((item)=>{
                            // const {carrierServiceCode,carrierCode,carrierServiceName}=item;
                            const {carrierServiceCode,carrierCode,carrierService}=item;
                            return h('Option', {
                                props: {
                                    value: carrierServiceCode,
                                    // label: carrierServiceCode+'( '+carrierCode+' '+carrierServiceName+' )'
                                    label: carrierServiceCode+'( '+carrierCode+' '+carrierService+' )'

                                }
                            });
                        })
                    )}
                },
                {
                    title: 'Tracking Method Carrier',
                    key: 'trackingMethodCarrier',
                    render:(h,{row,index})=>{
                        return h('vInput',{
                            props: {
                                size:'small',
                                value:row.trackingMethodCarrier
                            },
                            on: {
                                'input': (val) => {
                                    _this.datalist[index].trackingMethodCarrier = val
                                }
                            },
                        })
                    }
                },
                {
                    title: 'Tracking Method Code',
                    key: 'trackingMethodCode',
                    render:(h,{row,index})=>{
                        return h('vInput',{
                            props: {
                                size:'small',
                                value:row.trackingMethodCode
                            },
                            on: {
                                'input': (val) => {
                                    _this.datalist[index].trackingMethodCode =val
                                }
                            },
                        })
                    }
                },
                {
                    title: this.$t('erp.channelbase.is_disable', { defaultValue: '是否禁用' }),
                    key: 'status',
                    width:100,
                    render:(h, { row,index })=>{
                        return h('vCheckbox',{
                            props:{
                                value: row.status == "INACTIVE" ? true : false,
                            },
                            on: {
                                'on-change':(value) => {
                                    // let status = value == true ? 1 : 0
                                    this.datalist[index].status = value == true ? 'INACTIVE' : 'ACTIVE'
                                }
                            },
                        })

                    }
                },
            ]
        }
    },
    created(){
        this.update()
    },
    methods: {
        clickclear(){
            this.modalProps = {
                show: true,
                alert: "error",
                title: "全部清除",
                desc: this.$t('erp.channelbase.clear_channel_tip', { defaultValue: '清除后该渠道默认使用全局的发运方式' }),
                width: 460,
                params:{accountId:this.id},
                ajaxRequest:HttpClearAll,
                callback:()=>{
                    this.modalProps.show = false;
                    this.update()
                }
            };
        },
        update(type){
            this.loading = true
            this.formData.contextId =  global.SYSID
            this.formData.accountId = this.id
            if(type=='new'){
                this.formData = {
                    page: 1,
                    rows: 10,
                    sidx: "id",
                    sord: "desc",
                    accountCarrier:this.formData.accountCarrier,
                    accountSmc:this.formData.accountSmc,
                    bossSmc:this.formData.bossSmc,
                    status:this.formData.status,
                };
            }
            HttpGetAccountShipping({
                contextId:global.SYSID,
                accountId:this.id,
                ...this.formData
            }).then(res=>{
                this.datalist = res.data.content;
                // 没数据的时候展示沿用站点数据
                if (res.data.content && res.data.content[0]) {
                    this.isSite = res.data.content[0].isSite || false;
                }
                else {
                    this.isSite = true;
                }
                this.handleRequest(res.data)
                if(res.data.totalElements==0){
                    this.showsubmit = false
                }else{
                    this.showsubmit = true
                }
            },err=>{
                this.errorMessage(err.message);
            }).finally(res=>{
                this.loading = false
            })
        },
        reset(){
            this.formData = {
                page: 1,
				rows: 10,
				sidx: "id",
				sord: "desc",
                accountCarrier:'',
                accountSmc:'',
                bossSmc:'',
                status:'',
            };
            this.update()
        },
        handleRequest(data){
            this.totalNumber = data.totalPages
            if(this.formData.page>this.totalNumber-1){
                this.nextbtn = false
            }else{
                this.nextbtn = true
            }
        },
		submit() {
            if(this.formData.page>0){
                this.arrayList.push(this.datalist)
            }
            let arraies = []
            this.arrayList.map(item=>{
                // console.log(item)
                item.map(json=>{
                    arraies.push(json)
                })
            })
            // console.log(arraies)
            this.modalProps = {
                show: true,
                alert: 'warning',
                title: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                desc: this.$t('erp.channelbase.save_tip', { defaultValue: '保存后该渠道的发运方式将变为单独设置，不再沿用全局预设的映射关系，请谨慎操作！' }),
                ajaxRequest: HttpSaveAccountShipping,
                interceptRequest: (data) => {
                    // this.loading = true
                    return {
                        orgId:global.SYSID,
                        accountId:this.id,
                        accountFlag:this.flag,
                        accountTitle:this.title,
                        shipmentRequests:arraies
                    }
                },
                callback: (res) => {
                    this.$Message.success(res.message);
                    this.update(),
                    // this.loading = false;
                    this.arrayList = []
                    this.cancel()
                }
            }
            
            // HttpSaveAccountShipping({
            //     orgId:global.SYSID,
            //     accountId:this.id,
            //     accountFlag:this.flag,
            //     accountTitle:this.title,
            //     shipmentRequests:arraies
            // }).then(res=>{
            //     this.$Message.success(res.message);
            //     this.update()
            // },err=>{
            //     this.errorMessage(err.message);
            // }).finally(res=>{
            //     this.loading = false;
            //     this.arrayList = []
            // })
		},
		cancel(){
            // channelBase
            this.$router.push({
                name: 'channelBase',
            });
        },
        lastPage(){
            this.formData.page--;
            // console.log(this.formData.page)
            if(this.formData.page<2){
                this.lastbtn = false
            }else{
                this.lastbtn = true
            }
            this.getajax()
            this.arrayList.pop()
            // console.log(this.arrayList)
        },
        nextPage(){
            this.formData.page++;
            // console.log(this.formData.page)
            this.lastbtn = true
            this.arrayList.push(this.datalist)
            this.getajax()
        },
        getajax(){
            HttpGetAccountShipping({
                contextId:global.SYSID,
                accountId:this.id,
                page: this.formData.page,
				rows: 10,
				sidx: "id",
				sord: "desc",
                accountCarrier:this.formData.accountCarrier,
                accountSmc:this.formData.accountSmc,
                bossSmc:this.formData.bossSmc,
                status:this.formData.status,
            }).then(res=>{
                this.datalist = res.data.content
                this.handleRequest(res.data)
            },err=>{
                this.errorMessage(err.message);
            }).finally(res=>{
                this.loading = false
            })
        }
	},
}

</script>

